import script from "./DictionaryTemplates.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryTemplates.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryTemplates.vue?vue&type=style&index=0&id=19e1884e&scoped=true&lang=scss"
import "./DictionaryTemplates.vue?vue&type=style&index=1&id=19e1884e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e1884e"]])

export default __exports__